<style lang="scss" src='./CourseStations.scss' scoped></style>
<template src="./CourseStations.html"></template>

<script>
  import CourseStationList from '@/views/course/setup/stations/stationList/CourseStationList.vue';
  import CourseNewStation from '@/views/course/setup/stations/newStation/CourseNewStation.vue';
  import { mapState } from 'vuex';

  export default {
    name: 'CourseStations',
    components: {
      CourseStationList,
      CourseNewStation,
    },

    data() {
      return {
      };
    },

    computed: {
      ...mapState('CourseSetup', {
        showNewStationPage: (state) => state.showNewStationPage,
      }),
    },

    watch: {
    },

    methods: {
    },

    activated() {
    },

    mounted() {
      if (process.env.VUE_APP_SENTRY_ENV == "production") {
        this.$analytics.setCurrentScreen("Web Golf Weather Station");
        this.$analytics.logEvent("web_golf_weather_station");
      }
    },

    beforeDestroy() {
    },
  };

</script>
